'use client';
/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { Box, Button, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';

/* Services */

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */
const AboutAwards = ({ sectionContent }) => {
  const { titleText, titleSubtext } = sectionContent.find(
    section => section._modelApiKey === 'section_title'
  );
  const { cards } = sectionContent.find(
    section => section._modelApiKey === 'card_horizontal_group'
  );

  const [showAll, setShowAll] = useState(false);

  return (
    <Box
      width={'100%'}
      bg={'black'}
      pt={{ base: '12rem', '2xl': '20rem' }}
      pb="12rem"
    >
      <Box mx={{ lg: '224px', base: '1rem' }} textAlign="center" bg={'black'}>
        <Box
          mb={{ base: '2rem' }}
          gap={{ lg: '.5rem' }}
          display={'flex'}
          alignItems={{ base: 'center' }}
          justifyContent={'center'}
          fontSize={{ md: '2.25rem', base: '1.5rem' }}
          letterSpacing={'0.16px'}
          lineHeight={{ base: '1.8rem', md: '2.7rem' }}
          fontWeight={400}
        >
          <Text
            fontFamily={'var(--FedraSerifDisplay-Regular)'}
            color={'#FEFAF6'}
          >
            {titleText}
          </Text>
          <Text
            color={'#60ADFF'}
            ml={{ base: '.5rem' }}
            fontFamily={'var(--FedraSerifDisplay-Bold)'}
          >
            {titleSubtext}
          </Text>
        </Box>

        <Box>
          {cards.slice(0, showAll ? cards.length : 3).map((awards, index) => {
            const imageUrl =
              awards.thumbnails.length > 0
                ? awards.thumbnails[0].url
                : '/assets/images/Pattern.jpg'; // Default image if no thumbnail

            return (
              <Box marginY={{ lg: '2rem', base: '1rem' }} key={index}>
                <Box
                  bg={{
                    md: 'linear-gradient(90deg, rgba(9, 13, 17, 0) 6.5%, rgba(9, 13, 17, 0.577724) 19.5%, rgba(9, 13, 17, 0.935) 61.5%, #090D11 100%)',
                    base: 'linear-gradient(360deg, #090F11 0%, rgba(9, 13, 17, 0.935) 38.5%, rgba(9, 13, 17, 0.577724) 80.5%, rgba(9, 13, 17, 0) 93.5%)',
                  }}
                  py={{ md: '1.5rem' }}
                  paddingRight={{ lg: '2.1rem' }}
                  // p={"24px 56px 24px 0px"}
                  gap={{ base: '.5rem', md: '2rem' }}
                  maxW="974px"
                  minHeight={{ lg: '234px' }}
                  mx="auto"
                  alignItems={'center'}
                  justifyContent={{ lg: 'center' }}
                  display="flex"
                  flexDirection={{
                    md: 'row',
                    base: 'column',
                  }}
                >
                  <Box
                    p={{ md: '2rem', base: '.5rem', '2xl': '1.5rem' }}
                    mt={{ base: '1.5rem', md: '0' }}
                    boxSizing="border-box"
                    bgColor={'#0E1216'}
                    display="flex"
                    width={{ base: '11.625rem', lg: '186px' }}
                    height={{ base: '186px', lg: '153px' }}
                    // height={'11.625rem'}
                    gap={'8px'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <LazyLoadImageComponent
                      position="relative"
                      alt="logo"
                      title="logo"
                      src={imageUrl}
                    />
                  </Box>

                  <Box
                    w={{ md: '100%' }}
                    textAlign={{ base: 'left' }}
                    letterSpacing={'0.32px'}
                    p={{ base: '24px', md: '0' }}
                    mt={{ base: '1rem', md: '' }}
                    color="rgba(254, 250, 246, 0.9)"
                  >
                    <Box
                      fontSize={{ base: '1.25rem', '2xl': '1.4375rem' }}
                      lineHeight={{ md: '2.3rem', base: '2rem' }}
                      fontFamily="var(--FedraSansStd-medium)"
                      color="#FEFAF6"
                    >
                      {awards.title}
                    </Box>
                    <Box
                      fontSize={{ md: '1.125rem', base: '1rem' }}
                      // fontWeight={400}
                      lineHeight={{ md: '1.8rem', base: '1.6rem' }}
                      fontFamily="var(--FedraSansStd-book)"
                    >
                      {
                        awards.description.value.document.children[0]
                          .children[0].value
                      }
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}

          {!showAll && (
            <Button
              onClick={() => setShowAll(true)}
              textAlign={'center'}
              fontSize={'1rem'}
              bgColor={'#60ADFF'}
              height={'3.125rem'}
              width={'10.25rem'}
              borderRadius={'none'}
              lineHeight={'1.6rem'}
              letterSpacing={'0.32px'}
              fontFamily={'var(--FedraSansStd-medium)'}
              fontWeight={500}
              py={'0.75rem'}
              px={'2rem'}
              mt={'2.5rem'}
              _hover={{
                bg: '#80BDFF', // Sets the background color on hover
              }}
              textColor={'black'}
            >
              VIEW MORE
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AboutAwards;
